import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MultiSelectSvg = function MultiSelectSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.663 3.283h10.054v9.198H22V2H10.663zM14.974 10.73l-5.227 6.534-3.312-2.838.836-.975 2.303 1.975 4.398-5.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 22V4.674h17.326V22zM3.283 5.957v14.76h14.76V5.957z",
    clipRule: "evenodd"
  }));
};
export var MultiSelect = function MultiSelect(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MultiSelectSvg
  }));
};